import _ from 'lodash';

const selDirmayor = (list1, argsSelDpto, codigoCiudadUA) => {
  // console.log(list1, argsSelDpto, codigoCiudadUA)
  let listCiu = [], listZon = [], listBar = []
  listCiu.push({nombreCiudad: "Todas..."})
  listZon.push({nombreZona: "Todas..."})
  listBar.push({nombreBarrio: "Todos..."})
  if(argsSelDpto._id){
    let miLista = document.getElementById("miLista");
    //Ciudades del Dpto seleccionado
    let indexSearchD = list1.findIndex(elementoD => elementoD._id===argsSelDpto._id)
    if(indexSearchD!==-1){
      let indexSearchC = -1, indexSearchZ = -1
      if(codigoCiudadUA==="Todas..."){
        listCiu = listCiu.concat(list1[indexSearchD].ciudades);
        miLista = document.getElementById("miLista1");
        if(miLista){
          let existe = "N"
          indexSearchC = listCiu.findIndex(elementoC => elementoC.codigoCiudad===miLista.options[miLista.selectedIndex].value)
          if(indexSearchC!==-1){
            existe = "S"
          }
          if(existe==="N"){
            miLista.options.selectedIndex = 0
          }
        }
      }else{
        listCiu = list1[indexSearchD].ciudades.filter(elemento => elemento.codigoCiudad===codigoCiudadUA)
      }
      //Zonas de la Ciudad seleccionada
      miLista = document.getElementById("miLista1");
      if(miLista){
        if(codigoCiudadUA==="Todas..."){
          indexSearchC = listCiu.findIndex(elementoC => elementoC.codigoCiudad===miLista.options[miLista.selectedIndex].value)
        }else{
          indexSearchC = 0
        }
        if(indexSearchC!==-1){
          listZon = listZon.concat(listCiu[indexSearchC].zonas);
          if(codigoCiudadUA==="Todas..."){
            let existe = "N"
            miLista = document.getElementById("miLista2");
            // console.log(miLista)
            if(miLista){
              indexSearchZ = listZon.findIndex(elementoZ => elementoZ.codigoZona===miLista.options[miLista.selectedIndex].value)
            }
            if(indexSearchZ!==-1){
              existe = "S"
            }
            if(miLista&&existe==="N"){
              miLista.options.selectedIndex = 0
            }
          }
        }
      }
      //Zonas de la Ciudad seleccionada
      miLista = document.getElementById("miLista2");
      // console.log(miLista)
      if(miLista){
        indexSearchZ = listZon.findIndex(elementoZ => elementoZ.codigoZona===miLista.options[miLista.selectedIndex].value)
      }
      if(indexSearchZ!==-1){
        let listaB = listZon[indexSearchZ].barrios
        listaB = _.orderBy(listaB, ['nombreBarrio'], ['asc'])
        for(let i=0; i<listaB.length; i++){
          listBar.push({codigoZona: listZon[indexSearchZ].codigoZona,
            nombreZona: listZon[indexSearchZ].nombreZona,
            codigoBarrio: listaB[i].codigoBarrio,
            nombreBarrio: listaB[i].nombreBarrio,
            codigoTipoDocT: listaB[i].codigoTipoDocT,
            numeroDocumT: listaB[i].numeroDocumT,
            descrRecursoT: listaB[i].descrRecursoT,
            codigoTipoDocR: listaB[i].codigoTipoDocR,
            numeroDocumR: listaB[i].numeroDocumR,
            descrRecursoR: listaB[i].descrRecursoR,
          })
        }
        miLista = document.getElementById("miLista3");
        // console.log(miLista)
        let existe = "N"
        let indexSearchB = -1
        if(miLista){
          indexSearchB = listBar.findIndex(elementoB => elementoB.codigoBarrio===miLista.options[miLista.selectedIndex].value)
        }
        if(indexSearchB!==-1){
          existe = "S"
        }
        if(miLista&&existe==="N"){
          miLista.options.selectedIndex = 0
        }
      }
    }
  }else{
    if(argsSelDpto._id===""){
      let miLista = document.getElementById("miLista");
      miLista.options.selectedIndex = 0
      miLista = document.getElementById("miLista1");
      miLista.options.selectedIndex = 0
      miLista = document.getElementById("miLista2");
      // console.log(miLista)
      if(miLista){
        miLista.options.selectedIndex = 0
      }
      miLista = document.getElementById("miLista3");
      // console.log(miLista)
      if(miLista){
        miLista.options.selectedIndex = 0
      }
    }
  }

  let colecc = {listCiu, listZon, listBar}

  return colecc
}

export default selDirmayor
